import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { getErrorMessage } from "@/lib/api";
import AuthShell from "./AuthShell";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [orgName, setOrgName] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) {
      toast.error("Le mot de passe doit contenir au moins 8 caractères.");
      return;
    }
    setLoading(true);
    try {
      await register(email, password, name, orgName);
      toast.success("Compte créé. Un e-mail de vérification a été envoyé.");
      nav("/");
    } catch (err) {
      toast.error(getErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Créer un compte"
      subtitle="Vous serez administrateur de votre organisation."
    >
      <form onSubmit={submit} className="space-y-5" data-testid="register-form">
        <Field label="Nom de votre organisation">
          <input
            data-testid="register-org-name"
            required
            maxLength={120}
            value={orgName}
            onChange={(e) => setOrgName(e.target.value)}
            placeholder="ex : Cabinet Martin & Associés"
            className="w-full bg-white border border-zinc-300 px-4 py-2.5 text-sm focus:border-[#002FA7] focus:ring-1 focus:ring-[#002FA7] outline-none"
          />
        </Field>
        <Field label="Votre nom complet">
          <input
            data-testid="register-name"
            required
            maxLength={120}
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full bg-white border border-zinc-300 px-4 py-2.5 text-sm focus:border-[#002FA7] focus:ring-1 focus:ring-[#002FA7] outline-none"
          />
        </Field>
        <Field label="Adresse e-mail">
          <input
            data-testid="register-email"
            type="email"
            required
            maxLength={200}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full bg-white border border-zinc-300 px-4 py-2.5 text-sm focus:border-[#002FA7] focus:ring-1 focus:ring-[#002FA7] outline-none"
            autoComplete="email"
          />
        </Field>
        <Field label="Mot de passe (min. 8 caractères)">
          <input
            data-testid="register-password"
            type="password"
            required
            minLength={8}
            maxLength={128}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full bg-white border border-zinc-300 px-4 py-2.5 text-sm focus:border-[#002FA7] focus:ring-1 focus:ring-[#002FA7] outline-none"
          />
        </Field>
        <button
          data-testid="register-submit"
          disabled={loading}
          className="w-full bg-[#002FA7] hover:bg-[#00227A] text-white text-sm font-medium py-3 transition-colors disabled:opacity-50"
        >
          {loading ? "Création..." : "Créer mon organisation"}
        </button>
        <div className="text-xs text-zinc-600 pt-2">
          Vous avez déjà un compte ?{" "}
          <Link to="/login" className="text-[#002FA7] hover:underline" data-testid="login-link">
            Se connecter
          </Link>
        </div>
      </form>
    </AuthShell>
  );
}

function Field({ label, children }) {
  return (
    <label className="block">
      <span className="block text-[11px] uppercase tracking-[0.15em] text-zinc-500 font-mono mb-2">
        {label}
      </span>
      {children}
    </label>
  );
}
